import React from 'react';

import { Typography } from '@mui/material';
import CicEnteredBy from 'app/shared/components/CicEnteredBy';

import { getCicDisplayValue } from 'utils/cicReason';

import { renderCommentCell } from '../../LoanCicHistory.config';
import { EARLIER_REASONS_DESCRIPTION } from '../../LoanCicHistory.constants';
import { getWrappingCellStyles } from '../../LoanCicHistory.styles';
import { LoanCicHistoryTestIds } from '../../LoanCicHistory.testIds';

import { CicEarlierReasonColumnId } from './CicEarlierReasons.constants';

const renderReasonCell = ({ id, reasonName }) => (
  <Typography data-testid={LoanCicHistoryTestIds.getEarlierReasonRowId(id)} variant="regular14">
    {getCicDisplayValue(reasonName)}
  </Typography>
);

const renderFieldsCell = ({ fields }) => (
  <Typography variant="regular14">{getCicDisplayValue(fields?.join(', '))}</Typography>
);

const renderAddedByCell = ({ addedByName, addedDate }) => (
  <CicEnteredBy date={addedDate} name={addedByName} />
);

export const CIC_EARLIER_REASONS_TABLE_CONFIG = {
  [CicEarlierReasonColumnId.REASON]: {
    label: 'Reason',
    width: '22%',
    customStyles: getWrappingCellStyles,
    content: renderReasonCell,
  },
  [CicEarlierReasonColumnId.FIELDS]: {
    label: 'Fields',
    width: '24%',
    customStyles: getWrappingCellStyles,
    content: renderFieldsCell,
  },
  [CicEarlierReasonColumnId.COMMENT]: {
    label: 'Comment',
    width: '34%',
    customStyles: getWrappingCellStyles,
    content: renderCommentCell,
  },
  [CicEarlierReasonColumnId.ADDED_BY]: {
    label: 'Entered by',
    width: '20%',
    customStyles: getWrappingCellStyles,
    content: renderAddedByCell,
  },
};

export const EARLIER_REASONS_SUMMARY = (
  <Typography color="text.secondary" variant="regular12">
    {EARLIER_REASONS_DESCRIPTION}
  </Typography>
);
